import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineDatasetPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineDatasetPage',
  setup(__props) {

    document.title = "Configure dataset"

    const tid = useOrganizationUnitId()
    const id = useId()
    const { useCurrentUserQuery, usePipelineDetailsQuery, useDatasetsOfOrganizationQuery, useCreateDatasetCommand, useAttachDatasetCommand } = useAdminConfigurePipelineDatasetPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const datasetId = computed(() => modelPipelineDetailsQueryV1.value?.DatasetId)
    const ownedBy = computed(() => modelPipelineDetailsQueryV1.value?.OwnedBy)
    const name = computed(() => modelPipelineDetailsQueryV1.value?.Name)

    const { runDatasetsOfOrganizationQueryV1, modelDatasetsOfOrganizationQueryV1 } = useDatasetsOfOrganizationQuery(tid)
    const datasets = computed(() => modelDatasetsOfOrganizationQueryV1.value?.Datasets)

    const { invokeCreateDatasetCommandV1, succeedCreateDatasetCommandV1 } = useCreateDatasetCommand(null, tid, userId, name)

    const { invokeAttachDatasetCommandV1, succeedAttachDatasetCommandV1 } = useAttachDatasetCommand(id, tid, userId)

    watch([succeedCreateDatasetCommandV1, succeedAttachDatasetCommandV1], (succeed) => {
        if (succeed) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
        runDatasetsOfOrganizationQueryV1()
    })

    function handleCreateDatasetCommandV1() {
        invokeCreateDatasetCommandV1({
            Id: datasetId,
            Name: `Dataset for ${name.value}`,
            OwnedBy: ownedBy.value
        })
    }

    function handleAttachDatasetCommandV1(datasetId) {
        invokeAttachDatasetCommandV1({
            DatasetId: datasetId
        })
    }

return { __sfc: true,tid, id, useCurrentUserQuery, usePipelineDetailsQuery, useDatasetsOfOrganizationQuery, useCreateDatasetCommand, useAttachDatasetCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, datasetId, ownedBy, name, runDatasetsOfOrganizationQueryV1, modelDatasetsOfOrganizationQueryV1, datasets, invokeCreateDatasetCommandV1, succeedCreateDatasetCommandV1, invokeAttachDatasetCommandV1, succeedAttachDatasetCommandV1, handleCreateDatasetCommandV1, handleAttachDatasetCommandV1 }
}

})